export default "__VITE_ASSET__Bci37t_0__"